//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ChevronsDownIcon, ChevronDownIcon, ChevronsUpIcon } from 'vue-feather-icons'
import { tasksSortOptions } from 'ct-constants'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'SortDropdown',
  components: {
    ChevronsDownIcon,
    ChevronDownIcon,
    ChevronsUpIcon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    sort: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    types () {
      return [
        {
          key: tasksSortOptions.DATE_ADDED,
          label: this.$t('tasks.dateAdded')
        },
        {
          key: tasksSortOptions.PRICE,
          label: this.$t('tasks.price')
        }
      ]
    }
  },
  methods: {
    selectSort (c) {
      this.$emit('select', c)
    }
  }
}
